(function() {
    class ReviewsCarouselAdev extends HTMLElement {
      constructor() {
        super();
        this.currentSlide = 0;
        this.autoplayInterval = null;

        this.id = this.dataset.id;
      }

      connectedCallback() {
        this.track = this.querySelector('.ai-reviews-track-adev');
        this.slides = this.querySelectorAll('.ai-reviews-slide-adev');
        this.dotsContainer = this.querySelector('.ai-reviews-dots-adev');
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = parseInt(this.dataset.interval) * 1000;

        this.createDots();
        this.updateSlide();

        if (this.autoplay && this.slides.length > 1) {
          this.startAutoplay();
        }

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay) {
            this.startAutoplay();
          }
        });
      }

      createDots() {
        this.slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.classList.add('ai-reviews-dot-' + this.id);
          dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
          if (index === 0) {
            dot.classList.add('active');
          }
          dot.addEventListener('click', () => {
            this.goToSlide(index);
            this.stopAutoplay();
          });
          this.dotsContainer.appendChild(dot);
        });
        this.dots = this.querySelectorAll('.ai-reviews-dot-' + this.id);
      }

      updateSlide() {
        const offset = -this.currentSlide * 100;
        this.track.style.transform = 'translateX(' + offset + '%)';

        this.dots.forEach((dot, index) => {
          if (index === this.currentSlide) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      goToSlide(index) {
        this.currentSlide = index;
        this.updateSlide();
      }

      nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.updateSlide();
      }

      startAutoplay() {
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => {
          this.nextSlide();
        }, this.interval);
      }

      stopAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }

    customElements.define('reviews-carousel-adev', ReviewsCarouselAdev);
  })();